import DiscountsListSFC from "./DiscountsList.vue";
export const DiscountsList = DiscountsListSFC;
